const ShowTheme = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const herobg = document.querySelector('.show-hero');
        const root = document.documentElement;

        if (herobg) {
            document.querySelector('html').classList.add('show-page');

            let primaryColour = getComputedStyle(root).getPropertyValue('--defined-primary-colour').trim();
            let secondaryColour = getComputedStyle(root).getPropertyValue('--defined-secondary-colour').trim();

            // If either colour isn't set, use the fallback from theatre theme colour (--primary)
            if (!primaryColour || !secondaryColour) {
                const fallback = getComputedStyle(root).getPropertyValue('--primary').trim();
                const fallbackSecondary = getComputedStyle(root).getPropertyValue('--secondary').trim();
                primaryColour = fallback;
                secondaryColour = fallbackSecondary;
            } else {
                document.querySelector('html').classList.add('has-theme');

                if (isLightColour(secondaryColour)) {
                    document.querySelector('html').classList.add('light-header');
                } else {
                    document.querySelector('html').classList.add('dark-header');
                }
            }

            // Create a <style> element to set theme variables
            const style = document.createElement('style');
            style.innerHTML = `
                :root {
                    --page-theme: ${secondaryColour};
                    --page-theme-alternate: ${primaryColour};
                    --page-theme-rgb: ${hexToRgbString(secondaryColour)};
                    --page-theme-alternate-rgb: ${hexToRgbString(primaryColour)};
                }
            `;
            document.head.appendChild(style);

            window.addEventListener('resize', debounce(() => {
                resizeUpdateHeader(primaryColour, secondaryColour);
            }, 250));

            resizeUpdateHeader(primaryColour, secondaryColour);

        } else {
            // Fallback if .show-hero is not found
            root.style.setProperty('--page-theme', 'var(--secondary)');
        }
    });

    function isLightColour(color) {
        const hex = color.replace('#', '');
        const c_r = parseInt(hex.substring(0, 0 + 2), 16);
        const c_g = parseInt(hex.substring(2, 2 + 2), 16);
        const c_b = parseInt(hex.substring(4, 4 + 2), 16);
        const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
        return brightness > 50;
    }

    function resizeUpdateHeader(primaryColour, secondaryColour) {
        const headerBacking = document.querySelector('.header-backing');
        if (headerBacking) {
            headerBacking.style.background = window.innerWidth < 1200 ? secondaryColour : primaryColour;
        }
    }

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    function hexToRgbString(hex) {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
          hex = hex.split('').map(char => char + char).join('');
        }
        const bigint = parseInt(hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
      
        return `${r}, ${g}, ${b}`;
    }
      
};

export default ShowTheme;
